import styled from 'styled-components'
import { TProgressProps } from 'types'

export const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
`

export const ProgressBack = styled.div<TProgressProps>`
  height: 2px;
  background-color: var(--gray200);
  width: calc((100% / ${({ totalSteps }) => totalSteps}) * ${({ num }) => num});
`

export const Progress = styled.div<TProgressProps>`
  height: 2px;
  background-color: var(--primary500);
  width: calc((100% / ${({ totalSteps }) => totalSteps}) * ${({ num }) => num});
`
